/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { rtsByElasticGet } from '../fn/rts/rts-by-elastic-get';
import { RtsByElasticGet$Params } from '../fn/rts/rts-by-elastic-get';
import { rtsByElasticIdpGet } from '../fn/rts/rts-by-elastic-idp-get';
import { RtsByElasticIdpGet$Params } from '../fn/rts/rts-by-elastic-idp-get';
import { rtsExportByElasticGet } from '../fn/rts/rts-export-by-elastic-get';
import { RtsExportByElasticGet$Params } from '../fn/rts/rts-export-by-elastic-get';
import { rtsExportByElasticIdpGet } from '../fn/rts/rts-export-by-elastic-idp-get';
import { RtsExportByElasticIdpGet$Params } from '../fn/rts/rts-export-by-elastic-idp-get';
import { rtsExportTransactionDetailsGet } from '../fn/rts/rts-export-transaction-details-get';
import { RtsExportTransactionDetailsGet$Params } from '../fn/rts/rts-export-transaction-details-get';
import { rtsInboundAgingAndErrorsGet } from '../fn/rts/rts-inbound-aging-and-errors-get';
import { RtsInboundAgingAndErrorsGet$Params } from '../fn/rts/rts-inbound-aging-and-errors-get';
import { rtsInboundTransactionDetailsGet } from '../fn/rts/rts-inbound-transaction-details-get';
import { RtsInboundTransactionDetailsGet$Params } from '../fn/rts/rts-inbound-transaction-details-get';
import { rtsIngestionProcessingGet } from '../fn/rts/rts-ingestion-processing-get';
import { RtsIngestionProcessingGet$Params } from '../fn/rts/rts-ingestion-processing-get';
import { rtsIngestionProcessingStgGet } from '../fn/rts/rts-ingestion-processing-stg-get';
import { RtsIngestionProcessingStgGet$Params } from '../fn/rts/rts-ingestion-processing-stg-get';
import { rtsOutboundAgingAndErrorsGet } from '../fn/rts/rts-outbound-aging-and-errors-get';
import { RtsOutboundAgingAndErrorsGet$Params } from '../fn/rts/rts-outbound-aging-and-errors-get';
import { rtsOutboundAgingAndErrorsStgGet } from '../fn/rts/rts-outbound-aging-and-errors-stg-get';
import { RtsOutboundAgingAndErrorsStgGet$Params } from '../fn/rts/rts-outbound-aging-and-errors-stg-get';
import { rtsOutboundAgingGet } from '../fn/rts/rts-outbound-aging-get';
import { RtsOutboundAgingGet$Params } from '../fn/rts/rts-outbound-aging-get';
import { rtsTestPiplineGet } from '../fn/rts/rts-test-pipline-get';
import { RtsTestPiplineGet$Params } from '../fn/rts/rts-test-pipline-get';

@Injectable({ providedIn: 'root' })
export class RtsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `rtsTestPiplineGet()` */
  static readonly RtsTestPiplineGetPath = '/Rts/test-pipline';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsTestPiplineGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsTestPiplineGet$Response(params?: RtsTestPiplineGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsTestPiplineGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsTestPiplineGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsTestPiplineGet(params?: RtsTestPiplineGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsTestPiplineGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsInboundAgingAndErrorsGet()` */
  static readonly RtsInboundAgingAndErrorsGetPath = '/Rts/inbound-aging-and-errors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsInboundAgingAndErrorsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsInboundAgingAndErrorsGet$Response(params?: RtsInboundAgingAndErrorsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsInboundAgingAndErrorsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsInboundAgingAndErrorsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsInboundAgingAndErrorsGet(params?: RtsInboundAgingAndErrorsGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsInboundAgingAndErrorsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsOutboundAgingAndErrorsGet()` */
  static readonly RtsOutboundAgingAndErrorsGetPath = '/Rts/outbound-aging-and-errors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsOutboundAgingAndErrorsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsOutboundAgingAndErrorsGet$Response(params?: RtsOutboundAgingAndErrorsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsOutboundAgingAndErrorsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsOutboundAgingAndErrorsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsOutboundAgingAndErrorsGet(params?: RtsOutboundAgingAndErrorsGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsOutboundAgingAndErrorsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsOutboundAgingGet()` */
  static readonly RtsOutboundAgingGetPath = '/Rts/outbound-aging';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsOutboundAgingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsOutboundAgingGet$Response(params?: RtsOutboundAgingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsOutboundAgingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsOutboundAgingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsOutboundAgingGet(params?: RtsOutboundAgingGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsOutboundAgingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsExportTransactionDetailsGet()` */
  static readonly RtsExportTransactionDetailsGetPath = '/Rts/export-transaction-details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsExportTransactionDetailsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsExportTransactionDetailsGet$Response(params?: RtsExportTransactionDetailsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsExportTransactionDetailsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsExportTransactionDetailsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsExportTransactionDetailsGet(params?: RtsExportTransactionDetailsGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsExportTransactionDetailsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsByElasticGet()` */
  static readonly RtsByElasticGetPath = '/Rts/by-elastic';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsByElasticGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsByElasticGet$Response(params?: RtsByElasticGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsByElasticGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsByElasticGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsByElasticGet(params?: RtsByElasticGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsByElasticGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsExportByElasticGet()` */
  static readonly RtsExportByElasticGetPath = '/Rts/export-by-elastic';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsExportByElasticGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsExportByElasticGet$Response(params?: RtsExportByElasticGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsExportByElasticGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsExportByElasticGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsExportByElasticGet(params?: RtsExportByElasticGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsExportByElasticGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsByElasticIdpGet()` */
  static readonly RtsByElasticIdpGetPath = '/Rts/by-elastic-idp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsByElasticIdpGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsByElasticIdpGet$Response(params?: RtsByElasticIdpGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsByElasticIdpGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsByElasticIdpGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsByElasticIdpGet(params?: RtsByElasticIdpGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsByElasticIdpGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsExportByElasticIdpGet()` */
  static readonly RtsExportByElasticIdpGetPath = '/Rts/export-by-elastic-idp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsExportByElasticIdpGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsExportByElasticIdpGet$Response(params?: RtsExportByElasticIdpGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsExportByElasticIdpGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsExportByElasticIdpGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsExportByElasticIdpGet(params?: RtsExportByElasticIdpGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsExportByElasticIdpGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsInboundTransactionDetailsGet()` */
  static readonly RtsInboundTransactionDetailsGetPath = '/Rts/inbound-transaction-details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsInboundTransactionDetailsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsInboundTransactionDetailsGet$Response(params?: RtsInboundTransactionDetailsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsInboundTransactionDetailsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsInboundTransactionDetailsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsInboundTransactionDetailsGet(params?: RtsInboundTransactionDetailsGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsInboundTransactionDetailsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsIngestionProcessingGet()` */
  static readonly RtsIngestionProcessingGetPath = '/Rts/ingestion-processing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsIngestionProcessingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsIngestionProcessingGet$Response(params?: RtsIngestionProcessingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsIngestionProcessingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsIngestionProcessingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsIngestionProcessingGet(params?: RtsIngestionProcessingGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsIngestionProcessingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsOutboundAgingAndErrorsStgGet()` */
  static readonly RtsOutboundAgingAndErrorsStgGetPath = '/Rts/outbound-aging-and-errors-stg';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsOutboundAgingAndErrorsStgGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsOutboundAgingAndErrorsStgGet$Response(params?: RtsOutboundAgingAndErrorsStgGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsOutboundAgingAndErrorsStgGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsOutboundAgingAndErrorsStgGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsOutboundAgingAndErrorsStgGet(params?: RtsOutboundAgingAndErrorsStgGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsOutboundAgingAndErrorsStgGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rtsIngestionProcessingStgGet()` */
  static readonly RtsIngestionProcessingStgGetPath = '/Rts/ingestion-processing-stg';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rtsIngestionProcessingStgGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsIngestionProcessingStgGet$Response(params?: RtsIngestionProcessingStgGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rtsIngestionProcessingStgGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rtsIngestionProcessingStgGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rtsIngestionProcessingStgGet(params?: RtsIngestionProcessingStgGet$Params, context?: HttpContext): Observable<void> {
    return this.rtsIngestionProcessingStgGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
